import { YesNoDialogProps } from "components/dialogs/YesNoDialog";
import { useCallback, useState } from "react";
import useIsMounted from "./useIsMounted";

const useShowDialog = () => {
  const [dialogState, setDialogState] = useState<YesNoDialogProps>({
    type: "success",
    yesButtonText: "Confirm",
    onYesButtonClicked: () => {},
    noButtonText: "Cancel",
    onNoButtonClicked: () => {},
    yesButtonStartIcon: undefined,
    open: false,
    title: "",
    contentText: "",
    alertText: "",
  });

  const isMounted = useIsMounted();

  const showDialog = useCallback(
    ({
      type = "success",
      yesButtonText = "Confirm",
      onYesButtonClicked = () => {},
      noButtonText = "Cancel",
      yesButtonStartIcon = undefined, 
      onNoButtonClicked = () => {},
      title = "",
      contentText = "",
      alertText = "",
    }: YesNoDialogProps) => {
      if (isMounted()) {
        setDialogState({
          type,
          yesButtonText,
          onYesButtonClicked,
          noButtonText,
          onNoButtonClicked,
          yesButtonStartIcon, 
          open: true,
          title,
          contentText,
          alertText,
        });
      }
    },
    [isMounted]
  );

  const hideDialog = () => {
    if (isMounted()) {
      setDialogState((state) => ({
        ...state,
        open: false,
      }));
    }
  };

  return {
    showDialog,
    hideDialog,
    dialogState,
  };
};

export default useShowDialog;